module.exports = __webpack_public_path__ + "img/hibiscus-tea.9e61b4db.webp";